@if (showLoadingIndicator()) {
  <div class="loader">
    <span [innerHTML]="getLoadingIndicatorMessage()"></span>
  </div>
}